import React from 'react';
import styles from '../styles/SourdoughSection.module.css';

const SourdoughSection = ({
  label,
  title,
  text,
  benefitsTitle,
  benefits,
  imageSrc,
  imageAlt,
}) => (
  <div className={styles.block}>
    <div className={styles.heading}>
      <p className={styles.label}>{label}</p>
      <h2 id="sourdough-section-title">{title}</h2>
    </div>
    <section className={styles.section} aria-labelledby="sourdough-section-title">
      <div className={styles.copy}>
      <p>{text}</p>
      <h3>{benefitsTitle}</h3>
      <ul>
        {benefits.map((benefit, index) => (
          <li key={`${index}-${benefit}`}>{benefit}</li>
        ))}
      </ul>
      </div>
      <div className={styles.image}>
        <img src={imageSrc} alt={imageAlt} loading="lazy" decoding="async" />
      </div>
    </section>
  </div>
);

SourdoughSection.defaultProps = {
  label: '',
  title: '',
  text: '',
  benefitsTitle: '',
  benefits: [],
  imageSrc: '',
  imageAlt: 'Sourdough bread',
};

export default SourdoughSection;
